// extracted by mini-css-extract-plugin
export default {"background":"cP","weightImage":"eP","drinkImage":"fP","content":"gP","rtbLeft":"hP","rtbRight":"iP","rtbLeftMobile":"jP","imageContainer":"kP","rtbBox":"lP","line":"mP","rtbDesktop":"nP"};
    if(module.hot) {
      // 1714654894298
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  